// MUI
import { Paper } from "@mui/material";

// Hooks
import { useLocation } from "@/Common/hooks/Location/useLocation";

// Components
import ShowMessage from "./ShowMessage";
import ShowRegularInformation from "./ShowRegularInformation";
import LoadingState from "./LoadingState";

interface IShowInformationProps {
	show: boolean;
	loading: boolean;
	error: boolean;
	useAlternative: boolean;
	alternativeMessage: string;
	format: string;
	createdBy?: string;
	updatedBy?: string;
	alternativeDate: Date | null | undefined;
	createdAt?: string | Date;
	updatedAt?: string | Date;
}

const ShowInformation = (props: IShowInformationProps) => {
	const { show, loading, error, useAlternative, alternativeMessage, format, alternativeDate } = props;
	const location = useLocation();

	if (loading) {
		return <LoadingState useAlternative={useAlternative} />;
	}

	if (!show) {
		return null;
	}

	return (
		<Paper elevation={0} className="!bg-transparent">
			{useAlternative ? (
				<ShowMessage
					message={alternativeMessage}
					dateToUse={alternativeDate}
					format={format}
					error={error}
					iconError={true}
					location={location}
					showIcon={true}
				/>
			) : (
				<ShowRegularInformation {...props} location={location} />
			)}
		</Paper>
	);
};

export default ShowInformation;
